// Shared audio manager to coordinate multiple audio sources
class AudioManager {
  constructor() {
    this.backgroundMusicRef = null;
    this.isBackgroundMusicPlaying = false;
  }

  setBackgroundMusic(audioRef, isPlaying) {
    this.backgroundMusicRef = audioRef;
    this.isBackgroundMusicPlaying = isPlaying;
  }

  pauseBackgroundMusic() {
    if (this.backgroundMusicRef && !this.backgroundMusicRef.paused) {
      this.backgroundMusicRef.pause();
      this.isBackgroundMusicPlaying = true; // Remember it was playing
      return true;
    }
    return false;
  }

  resumeBackgroundMusic() {
    if (this.backgroundMusicRef && this.isBackgroundMusicPlaying) {
      this.backgroundMusicRef.play().catch(err => {
        console.log('Resume background music failed:', err);
      });
    }
  }
}

export const audioManager = new AudioManager();
